import dynamic from "next/dynamic";
import React, { useEffect } from "react";
const Navbar = dynamic(() => import("../components/Navbar"), {
  ssr: false,
});
import { useState } from "react";
import industriesData from "../utils/industries.json";
import CarouselContainer from "../components/reusable/CarouselContainer";
import { CapabilityCard, CapabilityCard2 } from "../components/services/Capabilities2";
import useScreenSize from "../hooks/useScreenSize";
import FullScreenModal from "./reusable/FullScreenModal";

const IndustryPage = ({ ...rest }) => {
  const size = useScreenSize();
  const isSmall = size == "sm" || size == "md";
  const [selectedItem, setselectedItem] = useState("");
  const [currentBlog, setcurrentBlog] = useState({});
  const [modalConfig, setmodalConfig] = useState({
    open: false,
    children: <></>,
  });
  useEffect(() => {
    if (size && !isSmall) {
      setselectedItem("Banking and Payments");
    } else {
      setselectedItem("");
    }
  }, [size]);

  useEffect(() => {
    const contentIdx = industriesData.findIndex(item => item.mainHeading === selectedItem);
    if (contentIdx != -1) {
      let selected = industriesData[contentIdx];
      setcurrentBlog({ title: selected.heading, subtitle: selected.paragraph, img: selected.image, category: selected.category, link: selected.link });

      if (isSmall) {
        setmodalConfig({
          open: true,

          children: (
            <CapabilityCard
              title={selected.title}
              subtitle={selected.paragraph}
              knowMoreLink={selected.link}
              hideTitle
              imgStyle="rounded-[100%] h-[300px] w-[300px]"
            />
          ),
        });
      }
    }
  }, [selectedItem, isSmall]);

  return (
    <div className="bg-white" id="Industry" {...rest}>
      <Navbar />
      {/* industry */}
      <div className="min-h-screen bg-[#59aec3]">
        <div className="mx-auto max-w-[1600px] w-[90%] md:w-[85%] bg-[#59aec3] pt-[80px] md:pt-[150px]">
          <h1 className="text-4xl font-bold mb-4 text-white">Industries we serve</h1>
          <div className="w-[200px] h-[1px] bg-white mb-4"></div>

          <div>
            <div className="flex justify-between mt-2 w-[100%]  ">
              <div className="w-[100%] md:w-[40%] text-black cursor-pointer pl-4">
                <>
                  {isSmall ? (
                    <CarouselContainer>
                      {industriesData.map(industry => {
                        return (
                          <div key={industry.title} className=" mb-6 py-4 px-4 w-[90%] mx-auto ">
                            <CapabilityCard2
                              key={industry.title}
                              title={`${industry.mainHeading} - \n ${industry.heading}`}
                              subtitle={industry.paragraph}
                              img={industry.image}
                              imgStyle=" rounded-[100%] !h-[200px] !w-[200px]"
                              onHoverStart={() => setselectedItem(industry.mainHeading)}
                              activeItem={selectedItem}
                              isSmall={isSmall}
                              hideBtn
                            />
                          </div>
                        );
                      })}
                    </CarouselContainer>
                  ) : (
                    industriesData.map(industry => {
                      return (
                        <CapabilityCard2
                          key={industry.mainHeading}
                          title={industry.mainHeading}
                          onHoverStart={() => setselectedItem(industry.mainHeading)}
                          activeItem={selectedItem}
                          isSmall={isSmall}
                          hideSubtitle
                          styleClass="mb-1 "
                        />
                      );
                    })
                  )}
                </>
              </div>
              <div className="hidden md:block md:w-[50%] whitespace-pre-line ">
                {selectedItem && currentBlog?.title ? (
                  <CapabilityCard
                    title={`${currentBlog.title}`}
                    subtitle={currentBlog.subtitle}
                    img={currentBlog.img}
                    knowMoreLink={currentBlog.link}
                    styleClass="mt-[-100px]"
                    imgStyle=" rounded-[100%] !h-[260px] !w-[260px]"
                    inactiveColor="white"
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <FullScreenModal
        isOpen={modalConfig.open}
        onClose={() => {
          setmodalConfig(() => ({ open: false, children: <></> }));
          setselectedItem("");
        }}
        styleClass="[&>div]:!bg-[#59aec3]"
      >
        {modalConfig.children}
      </FullScreenModal>
    </div>
  );
};

export default IndustryPage;